import React from 'react'
import Head from './Head'
import Navbar from './Navbar'

const Header = () => {
  return (
    <>
    <Head/>
    <Navbar/>
    </>
  )
}

export default Header